import { render, staticRenderFns } from "./pieLeft.vue?vue&type=template&id=d855f7c0&scoped=true&"
import script from "./pieLeft.vue?vue&type=script&lang=js&"
export * from "./pieLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d855f7c0",
  null
  
)

export default component.exports